/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Schedule2 } from './Schedule2';
import {
    Schedule2FromJSON,
    Schedule2FromJSONTyped,
    Schedule2ToJSON,
} from './Schedule2';

/**
 * 
 * @export
 * @interface WorkSchedulePeriod2
 */
export interface WorkSchedulePeriod2 {
    /**
     * 
     * @type {string}
     * @memberof WorkSchedulePeriod2
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedulePeriod2
     */
    endDate: string;
    /**
     * 
     * @type {Schedule2}
     * @memberof WorkSchedulePeriod2
     */
    schedule: Schedule2;
}

/**
 * Check if a given object implements the WorkSchedulePeriod2 interface.
 */
export function instanceOfWorkSchedulePeriod2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "schedule" in value;

    return isInstance;
}

export function WorkSchedulePeriod2FromJSON(json: any): WorkSchedulePeriod2 {
    return WorkSchedulePeriod2FromJSONTyped(json, false);
}

export function WorkSchedulePeriod2FromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkSchedulePeriod2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'schedule': Schedule2FromJSON(json['schedule']),
    };
}

export function WorkSchedulePeriod2ToJSON(value?: WorkSchedulePeriod2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate,
        'endDate': value.endDate,
        'schedule': Schedule2ToJSON(value.schedule),
    };
}

